import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
class HeightPin extends React.Component {
    constructor() {
        super();
        this.lastTop = 0;
        this.lastBottom = 0;
        this.lastHeight = 0;
    }

    setScrollElem(r) {
        this.scrollElementRef = r;
        this.updateScrollData();
    }

    componentDidUpdate() {
        this.updateScrollData();

    }

    updateScrollData() {
        if (!this.scrollElementRef) return;
        this.scrollRect = this.scrollElementRef.getBoundingClientRect();
        if (this.lastTop === this.scrollRect.top) return;

        this.lastTop = this.scrollRect.top;
        this.lastHeight = this.scrollRect.height;
        this.lastBottom = document.documentElement.clientHeight - this.scrollRect.bottom;//distance off bottom of screen
    }

    render() {
        const {scrollChild, pinChild, state, store} = this.props;

        if (store.interactionsStore.mobileMode) {
            return <div className={'HeightPin'}>
                <div className={'mobile-inline'}>
                    {scrollChild}
                </div>
            </div>
        }

        const pinnedStyle = {};
        const pinnedTop = Math.max(0, -this.lastTop);

        let fullHeight = document.documentElement.clientHeight;

        if (this.lastHeight < fullHeight || state==='OFF-SCREEN') {
            pinnedStyle.top = 0;
            pinnedStyle.height = fullHeight;
            pinnedStyle.position = 'absolute'
        } else {
            if (pinnedTop > 0) {
                // pinnedStyle.top = pinnedTop;
                pinnedStyle.top = 0;
                pinnedStyle.bottom = 0;
                pinnedStyle.height = 'auto';
                pinnedStyle.position = 'fixed'
            } else {
                pinnedStyle.top = 0;
                pinnedStyle.height = fullHeight;
                pinnedStyle.position = 'absolute'
            }

            if (this.lastBottom > 0) {
                pinnedStyle.top = 'auto';
                pinnedStyle.bottom = 0;
                pinnedStyle.height = fullHeight;
                pinnedStyle.position = 'absolute'
            }
        }


        return (
            <div className={'HeightPin'}>
                <div className={'scroller'} ref={(r) => this.setScrollElem(r)}>
                    {scrollChild}
                </div>
                <div className={'pinned'} style={pinnedStyle}>
                    {pinChild}
                </div>
            </div>
        );
    }
}

export default observer(HeightPin);
